import { CopyType } from './types';
import { VEEQO_COPY } from './veeqo';

export const SE_CE_COPY: CopyType = {
  ...VEEQO_COPY,
  inlineSubtitleTextId: 'sece_inline_subtitle_text',
  progressId: 'sece_progress',
};
